import React, { Fragment } from 'react'
import {AppTableSearchProps,AppTableSearchContext,AppFilter,AppTableSearchServer} from './AppTableSearchServer'
import {AppTableSearchCommon} from './AppTableSearchCommon'
import {AppTableSearchAdvanced} from './AppTableSearchAdvanced'
import {AppTableFilter} from './AppTableFilter'
import './index.less'

export class AppTableSearch extends React.Component<AppTableSearchProps> {
    static Common = AppTableSearchCommon
    static Advanced =AppTableSearchAdvanced
    state ={
        data:this.props.defaultData||{},
        showMore:this.props.showMore || false,
        filterList:[] as AppFilter[]
    }

    // componentDidMount (){
       
    // }

    // componentDidUpdate () {
    //     console.log('this.refDiv.current.clientHeight:',this.refDiv.current.clientHeight)
    // }

    onItemChange = (filter?:AppFilter) =>{
       
        if(filter && filter.keyName){
            let filterList = AppTableSearchServer.hanldItemChange(this.state.filterList,filter);
            let data = AppTableSearchServer.handleData(filter,this.state.data);
            this.setState({filterList,data})
        }
        
    }

    onItemSearch = (filter?:AppFilter) =>{
        if(filter && filter.keyName){
            let filterList = AppTableSearchServer.hanldItemChange(this.state.filterList,filter);
            let data = AppTableSearchServer.handleData(filter,this.state.data);
            let queryFilterList = AppTableSearchServer.getQueryFilterList(filterList);
            this.props.onSearch && this.props.onSearch(queryFilterList,data)
            this.setState({filterList,data})
        }
    }

    onCloseItem = (filter?:AppFilter) =>{
        let filterList = this.state.filterList.filter(e => e.keyName !== filter.keyName);
        let data = AppTableSearchServer.getDataByFilterList(filterList);
        let queryFilterList = AppTableSearchServer.getQueryFilterList(filterList);
        this.props.onSearch && this.props.onSearch(queryFilterList,data)
        this.setState({filterList,data})
    }

    onSearch = () =>{
        let {data,filterList} = this.state;
        let queryFilterList = AppTableSearchServer.getQueryFilterList(filterList);
        this.props.onSearch && this.props.onSearch(queryFilterList,data);
    }

    handleClickMore = () =>{
        let showMore = ! this.state.showMore;
        this.setState({showMore});
    }

    clearSearch = () =>{
        let {data,filterList} = this.state
        let {newData,arrFilter} = AppTableSearchServer.clearSearch(filterList,data);
        this.setState({data:newData,filterList:arrFilter});
    }

    renderAdvancedFilter = () =>{
        let existAdvanced = (React.Children.toArray(this.props.children).length>1);
        let {showMore} = this.state
        if(!existAdvanced || showMore) return <Fragment/>
        let filterList = this.state.filterList.filter(e => e.describe !== '')
        if(filterList.length === 0) return <Fragment/>
        return <AppTableFilter filterList={filterList}/>
    }

    render(){
        let existAdvanced = (React.Children.toArray(this.props.children).length>1);
        let {data,showMore,filterList} = this.state
        let {onItemChange,onItemSearch,onCloseItem,onSearch,handleClickMore,clearSearch} = this
        let providerValue = {data,showMore,filterList,existAdvanced,onCloseItem,onItemChange,onItemSearch,onSearch,handleClickMore,clearSearch};
        return (<AppTableSearchContext.Provider value={providerValue}>
                    <div className='app-table-search' >
                        {this.props.children}
                        {this.renderAdvancedFilter()}
                    </div>
        </AppTableSearchContext.Provider>
        )
    }

}




// WEBPACK FOOTER //
// ./src/qcc/AppTableSearch/AppTableSearch.tsx